import React from "react";
import { Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import { IStatisticsData } from "../../types/api/aboutApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { IStatistics } from "../../types/features/multiLanguageSlice";

const AboutCounter: React.FC<{ statistics: Array<IStatisticsData> }> = ({ statistics }) => {
    const {t} = useTranslation()
const statistics_json = t('about_us.statistics', { returnObjects: true })  as IStatistics[];

    return (
        <div>
            <section className="about-counter">
                <div className="container">
                    <div className="counter-heading">
                        <h4 className="sub-title">{t('about_us.features')}</h4>
                        <h3 className="title">{t('about_us.hotel_statistics')}</h3>
                    </div>
                    <div className="counter-content">
                        <Row>
                            {
                                statistics_json && statistics_json.length ?
                                    statistics_json.map((statistic: IStatistics, index: number) => (
                                        <Col sm={6} md={3} lg={3}>
                                            <div className="counter-item">
                                                <CountUp end={statistic.count} duration={5} />
                                                <span>+</span>
                                                <h5>{statistic.title}</h5>
                                            </div>
                                        </Col>
                                    ))
                                    : <NoData message="Oopsm No Statistics Data Found!!" />
                            }
                        </Row>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutCounter;
